import type { XValueParams } from 'hb-builder/components/RenderComponents/page/single/PageImage/types';
import { HORIZONTAL_ALIGNMENT } from 'hb-builder/constants/alignment';

export const getXValue = ({
  horizontalAlign,
  defaultValue,
  imageWidth,
  wrapperWidth,
}: XValueParams) => {
  if (horizontalAlign === HORIZONTAL_ALIGNMENT.left) {
    return 0;
  }
  if (horizontalAlign === HORIZONTAL_ALIGNMENT.center) {
    return (wrapperWidth - imageWidth) / 2;
  }
  if (horizontalAlign === HORIZONTAL_ALIGNMENT.right) {
    return wrapperWidth - imageWidth;
  }

  return defaultValue;
};
